export const CERTIFICATE_ID_LENGTH = "12345678-1234-1234-1234-123456789abc".length;
